<template>
  <div class="d-flex" style="background-color:#233446;width:100%;height:60px;">
    <div class="align-self-cnter text-center font-weight-black" style="width:240px;color:#e4e6e8;line-height:60px;"> 
      <h2 style="color:#FFF;cursor:pointer;" @click="goHome()">E3Mobility</h2>
    </div>
    <div class="d-flex ml-3 pl-0 mr-auto gnb_list" >
      <div class="align-self-cnter "><router-link to="/Vehicle" :class="[gnbCode === '1'? 'gnb_active': 'gnb_non_active']">Vehicle</router-link></div>
      <div class="align-self-cnter ml-10"><router-link to="/Device" :class="[gnbCode === '2'? 'gnb_active': 'gnb_non_active']">Device</router-link></div>
      <div class="align-self-cnter ml-10"><router-link to="/Bss" :class="[gnbCode === '3'? 'gnb_active': 'gnb_non_active']">Charger</router-link></div>
      <div class="align-self-cnter ml-10"><router-link to="/Member" :class="[gnbCode === '5'? 'gnb_active': 'gnb_non_active']">Member</router-link></div>
      <div class="align-self-cnter ml-10"><router-link to="/Reserve" :class="[gnbCode === '4'? 'gnb_active': 'gnb_non_active']">Reserve</router-link></div>
      
      <!--
      <div class="align-self-cnter ml-10">요금제관리</div>
      <div class="align-self-cnter ml-10">API관리</div>
      <div class="align-self-cnter ml-10">고객센터</div> -->
      <div class="align-self-cnter ml-10"><router-link to="/Manager" :class="[gnbCode === '9'? 'gnb_active': 'gnb_non_active']">Setup</router-link></div>
     
    </div>
    <div class="d-flex " style="padding-right:25px;color:#e4e6e8;line-height:60px;">
      <div >
        <span style="font-size:15px; line-height:60px; color:#fff; font-weight:400;">{{loginInfo1}} </span><span style="padding-left:10px;font-size:12px; line-height:60px; color:#fff; font-weight:400;">[{{loginInfo2}}]</span>
        <v-btn small dense elvation="1" style="margin: 0 0 3px 10px; font-size:13px;  font-weight:400;" @click="confirmLogout">Logout</v-btn>
      </div>
    </div>

    <!-- confirm: logout -->
    <div class="text-center" >
        <v-dialog v-model="logoutFlag" width="400">
            <v-card>
                <v-card-title class="text-subtitle-1 pb-0">
                    <v-icon style='color:red;'>mdi-alert </v-icon>
                    <span class="pl-3">Are you sure you want to logout? </span>
                </v-card-title>
                <v-card-actions class="justify-end">
                    <v-btn color="error" text @click="logoutFlag = false">Disagree</v-btn>
                    <v-btn color="primary" text @click="logout">Agree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

  </div>
</template>
<style scoped>
 a {text-decoration: none !important;}
</style>

 
<script>
export default {
  name: 'Gnb',
  props: { loginInfo1: String, loginInfo2: String, gnbCode: String }, 
  data () {
    return { logoutFlag: false, }
  },
  created() {
    //console.log("gnbCode="+this.gnbCode)
  },
  methods:{
    goHome() {
      this.$router.push("/Vehicle");
    },
    confirmLogout() {
      this.logoutFlag=true;
    },
    logout() {
      localStorage.clear();
      this.logoutFlag = false;
      this.$router.push('/');
    }
  },
}
</script>